var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6096 7.75244C35.0421 7.57042 35.5154 7.50765 35.9804 7.57064C36.4453 7.63364 36.8849 7.82011 37.2533 8.11064C37.6218 8.40117 37.9056 8.78514 38.0753 9.22258C38.245 9.66003 38.2943 10.135 38.2181 10.5979L34.2491 34.6727C33.8641 36.9949 31.3161 38.3267 29.1864 37.1699C27.4049 36.2022 24.7589 34.7112 22.3789 33.1554C21.1889 32.3767 17.5436 29.8829 17.9916 28.1084C18.3766 26.5912 24.5016 20.8897 28.0016 17.4999C29.3754 16.1682 28.7489 15.3999 27.1266 16.6249C23.0981 19.6664 16.6301 24.2917 14.4916 25.5937C12.6051 26.7417 11.6216 26.9377 10.4456 26.7417C8.30013 26.3847 6.31038 25.8317 4.68638 25.1579C2.49188 24.2479 2.59863 21.2309 4.68463 20.3524L34.6096 7.75244Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d3699df1685ff1aef8f25778b8c9fe31.svg";
export { ForwardRef as ReactComponent };